import { selector } from "recoil";
import { Point } from "../../generated/graphql";
import { routeSearchState } from "./routeSearchState";
import { floorState } from "./floorState";


export const floorlineEndPointState = selector<Point | null>({
    key: "floorlineEndPointState",
    get: ({ get }) => {
        const floor = get(floorState);
        const routeSearch = get(routeSearchState);
        const { lineEnd } = routeSearch;
        if (!lineEnd) return null;
        return lineEnd.floor_id == floor.id ? lineEnd : null;
    },
});
